<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  event: {
    id?: string | number | null
    name: string
    startDate?: string | null
    endDate?: string | null
    status?: string | null
    location?: {
      type?: string | null
      cityName?: string | null
      stateName?: string | null
      countryName?: string | null
    } | null
  }
}>()

const statusLabel = computed(() => {
  return t(`events.status.${String(props.event.status || '').toLowerCase()}`)
})

const locationString = computed(() => {
  const { cityName, stateName, countryName } = props.event.location || {}
  const parts = [cityName, stateName, countryName].filter(Boolean)
  return parts.length > 0 ? parts.join(' - ') : 'Local não disponível'
})

const formatString = computed(() => {
  const type = props.event.location?.type || ''
  return type ? t(`events.type.${type.toLowerCase()}`) : '--'
})

const formattedStartDate = computed(() =>
  props.event.startDate
    ? new Date(props.event.startDate).toLocaleDateString('pt-BR')
    : '--'
)

const formattedEndDate = computed(() =>
  props.event.endDate
    ? new Date(props.event.endDate).toLocaleDateString('pt-BR')
    : '--'
)
</script>

<template>
  <v-card class="elevation-2 mx-4" rounded="lg">
    <div class="pa-4">
      <div class="d-flex align-center justify-space-between">
        <span class="statusPublish">{{ statusLabel }}</span>
      </div>

      <div class="cardTitle" style="margin-top: 32px">
        {{ event.name }}
      </div>

      <div class="cardText mt-1">
        {{ formattedStartDate }} a {{ formattedEndDate }} - {{ formatString }}
      </div>

      <div class="cardText mt-1">
        <v-icon size="small" class="me-2">mdi-map-marker</v-icon>
        {{ locationString }}
      </div>
    </div>
  </v-card>
</template>
<style scoped>
.statusPublish {
  color: var(--opacity-text--secondary, rgba(0, 0, 0, 0.6));

  /* caption/caption */
  font-family: var(--Typography-fontFamilies-Open-Sans, 'Open Sans');
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
  letter-spacing: 0.048px;
}

.cardTitle {
  overflow: hidden;
  color: var(--opacity-text--primary, rgba(0, 0, 0, 0.87));
  text-overflow: ellipsis;

  /* subtitle-1/subtitle-1, medium */
  font-family: var(--Typography-fontFamilies-Open-Sans, 'Open Sans');
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px; /* 175% */
  letter-spacing: 0.024px;
}

.card {
  display: flex;
  min-width: 280px;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  flex: 1 0 0;
  border-radius: 4px;
  background: #fff;

  /* elevation/elevation-1 */
  box-shadow:
    0 2px 1px -1px rgba(0, 0, 0, 0.2),
    0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
}

.cardText {
  color: var(--opacity-text--secondary, rgba(0, 0, 0, 0.6));

  /* caption/caption */
  font-family: var(--Typography-fontFamilies-Open-Sans, 'Open Sans');
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
  letter-spacing: 0.048px;
}
</style>
